"use client";

import { useId } from "react";
import { FaSearch } from "react-icons/fa";

import {
  Input,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui";

import { cx } from "@/lib/tailwind-utils";

export interface CatalogFilterOption {
  value: string;
  label: string;
}

interface SearchCategoryFiltersProps {
  searchLabel: string;
  searchPlaceholder: string;
  searchValue: string;
  onSearchChange: (value: string) => void;
  showSearch: boolean;
  categoryLabel: string;
  categoryValue?: string;
  onCategoryChange: (value: string | undefined) => void;
  categories: CatalogFilterOption[];
  showCategories: boolean;
  className?: string;
}

export function SearchCategoryFilters({
  searchLabel,
  searchPlaceholder,
  searchValue,
  onSearchChange,
  showSearch,
  categoryLabel,
  categoryValue,
  onCategoryChange,
  categories,
  showCategories,
  className,
}: SearchCategoryFiltersProps) {
  const generatedId = useId();
  const searchId = `${generatedId}-search`;
  const categoryId = `${generatedId}-category`;

  if (!showSearch && !showCategories) return null;

  return (
    <div className={cx("space-y-2", className)}>
      {showSearch && (
        <div>
          <Label htmlFor={searchId}>{searchLabel}</Label>
          <div className="relative">
            <Input
              id={searchId}
              type="text"
              placeholder={searchPlaceholder}
              value={searchValue}
              icon={FaSearch}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                onSearchChange(event.target.value)
              }
            />
          </div>
        </div>
      )}
      {showCategories && (
        <div>
          <Label htmlFor={categoryId}>{categoryLabel}</Label>
          <Select
            value={categoryValue ?? "all"}
            onValueChange={(value) =>
              onCategoryChange(value === "all" ? undefined : value)
            }
          >
            <SelectTrigger id={categoryId}>
              <SelectValue placeholder="Category" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Categories</SelectItem>
              {categories.map((category) => (
                <SelectItem key={category.value} value={category.value}>
                  {category.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}
